/* eslint-disable import/no-unresolved */
import '@menu/index.js';

$(() => $('html').trigger('consumer.dependencies.loaded'));
